export default __webpack_public_path__ + "static/media/quiz.13fd77d7.png";